import { css } from "styled-components";
import { useMediaQuery } from "react-responsive";

export const breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
};

// Mobile-first (min-width) helpers for styled-components
export const media = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

// Desktop-first (max-width) helpers for styled-components
export const mediaDown = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakpoints[label] - 1}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {});

// Responsive component wrappers (no orientation lock — fixes tablet landscape dead zone)
export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.lg });
  return isDesktop ? children : null;
};

export const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({
    minWidth: breakpoints.md,
    maxWidth: breakpoints.lg - 1,
  });
  return isTablet ? children : null;
};

export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.md - 1 });
  return isMobile ? children : null;
};

export const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: breakpoints.md });
  return isNotMobile ? children : null;
};
